/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPSWITCHFREQUENCY } from './IAPSWITCHFREQUENCY';
import {
    IAPSWITCHFREQUENCYFromJSON,
    IAPSWITCHFREQUENCYFromJSONTyped,
    IAPSWITCHFREQUENCYToJSON,
} from './IAPSWITCHFREQUENCY';
import type { ProposalSummaryPhaseInCollectiveInvestments } from './ProposalSummaryPhaseInCollectiveInvestments';
import {
    ProposalSummaryPhaseInCollectiveInvestmentsFromJSON,
    ProposalSummaryPhaseInCollectiveInvestmentsFromJSONTyped,
    ProposalSummaryPhaseInCollectiveInvestmentsToJSON,
} from './ProposalSummaryPhaseInCollectiveInvestments';

/**
 * 
 * @export
 * @interface ProposalSummaryPhaseInInstructions
 */
export interface ProposalSummaryPhaseInInstructions {
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryPhaseInInstructions
     */
    holdingFund?: string;
    /**
     * 
     * @type {IAPSWITCHFREQUENCY}
     * @memberof ProposalSummaryPhaseInInstructions
     */
    frequency?: IAPSWITCHFREQUENCY;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryPhaseInInstructions
     */
    numberOfOccurrences?: number;
    /**
     * 
     * @type {Date}
     * @memberof ProposalSummaryPhaseInInstructions
     */
    nextDueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryPhaseInInstructions
     */
    switchAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryPhaseInInstructions
     */
    switchAmountPerOccurrence?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalSummaryPhaseInInstructions
     */
    immediateSwitch?: boolean;
    /**
     * 
     * @type {Array<ProposalSummaryPhaseInCollectiveInvestments>}
     * @memberof ProposalSummaryPhaseInInstructions
     */
    collectiveInvestments: Array<ProposalSummaryPhaseInCollectiveInvestments>;
}

/**
 * Check if a given object implements the ProposalSummaryPhaseInInstructions interface.
 */
export function instanceOfProposalSummaryPhaseInInstructions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "collectiveInvestments" in value;

    return isInstance;
}

export function ProposalSummaryPhaseInInstructionsFromJSON(json: any): ProposalSummaryPhaseInInstructions {
    return ProposalSummaryPhaseInInstructionsFromJSONTyped(json, false);
}

export function ProposalSummaryPhaseInInstructionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryPhaseInInstructions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'holdingFund': !exists(json, 'HoldingFund') ? undefined : json['HoldingFund'],
        'frequency': !exists(json, 'Frequency') ? undefined : IAPSWITCHFREQUENCYFromJSON(json['Frequency']),
        'numberOfOccurrences': !exists(json, 'NumberOfOccurrences') ? undefined : json['NumberOfOccurrences'],
        'nextDueDate': !exists(json, 'NextDueDate') ? undefined : (new Date(json['NextDueDate'])),
        'switchAmount': !exists(json, 'SwitchAmount') ? undefined : json['SwitchAmount'],
        'switchAmountPerOccurrence': !exists(json, 'SwitchAmountPerOccurrence') ? undefined : json['SwitchAmountPerOccurrence'],
        'immediateSwitch': !exists(json, 'ImmediateSwitch') ? undefined : json['ImmediateSwitch'],
        'collectiveInvestments': ((json['CollectiveInvestments'] as Array<any>).map(ProposalSummaryPhaseInCollectiveInvestmentsFromJSON)),
    };
}

export function ProposalSummaryPhaseInInstructionsToJSON(value?: ProposalSummaryPhaseInInstructions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'HoldingFund': value.holdingFund,
        'Frequency': IAPSWITCHFREQUENCYToJSON(value.frequency),
        'NumberOfOccurrences': value.numberOfOccurrences,
        'NextDueDate': value.nextDueDate === undefined ? undefined : (value.nextDueDate.toISOString()),
        'SwitchAmount': value.switchAmount,
        'SwitchAmountPerOccurrence': value.switchAmountPerOccurrence,
        'ImmediateSwitch': value.immediateSwitch,
        'CollectiveInvestments': ((value.collectiveInvestments as Array<any>).map(ProposalSummaryPhaseInCollectiveInvestmentsToJSON)),
    };
}

